<template>
  <div
    class="box-border inline-block rounded-md bg-structure-1 px-2 py-1 font-inter text-[13px] font-medium leading-6 text-gray-700"
    :class="{ '!text-xs': xs }"
  >
    <slot />
  </div>
</template>
<script lang="ts" setup>
defineProps<{
  xs?: boolean;
}>();
</script>
<style lang="scss"></style>
